import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../Util/Session/session.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ClientgroupMasterServiceService {

  constructor(private http: HttpClient,
    private session: SessionService,) {
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  ClientComboLoad(LocDetail: any) {
    return this.http.post<any>(environment.API_URL + `ClientGroupComboLoad/Load`,
      this.session.SetClass(LocDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ClientLoad(LocDetail: any) {
    return this.http.post<any>(environment.API_URL + `ClientGroupMaster_Select/Load`,
      this.session.SetClass(LocDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ClientGroupInserUpdate(LocDetail: any) {
    return this.http.post<any>(environment.API_URL + `ClientGroupInsert/Update`,
      this.session.SetClass(LocDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  //////////////////--Transovative Part--////////////////////////////

  SetSyncAPIFlagIn(SiteMasterDetail: any) {
    return this.http.post<any>(environment.API_URL + `SetSyncAPIFlagIn/Masters`,
      this.session.SetClass(SiteMasterDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  GetMaster(SiteMasterDetail: any) {
    return this.http.post<any>(environment.API_URL + `GetMaster/Data`,
      this.session.SetClass(SiteMasterDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
  SubMasterApi(SiteMasterDetail: any) {
    return this.http.post<any>(environment.API_URL + `TransovativeSubMasterApi/Consumption`,
      this.session.SetClass(SiteMasterDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
  Transovative_SubMasterApi_ConsumptionLogs(SiteMasterDetail: any) {
    return this.http.post<any>(environment.API_URL + `Transovative_SubMasterApi_ConsumptionLogs/Insert`,
      this.session.SetClass(SiteMasterDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
